var exports = {
  "k": "xcc377c0b--bb9e82--container",
};

module.exports = exports;
